import { DoctorStory } from '@/modules/JobListing/utils/JobListingTypes';

export const doctorStoryData: DoctorStory[] = [
  {
    id: 'priya-n',
    rating: 5,
    quote:
      "I sent my CV on a Tuesday and was covering ED shifts the following Monday. The accommodation and flights were sorted before I'd even signed.",
    authorName: 'Dr Priya N.',
    authorRole: 'Emergency Medicine Registrar',
    grade: 'Universal',
    tagLabel: 'Placed in 6 days · Locum',
    tagVariant: 'secondary',
  },
  {
    id: 'james-o',
    rating: 5,
    quote:
      "As an IMG the AHPRA pathway felt impossible until my consultant walked me through every step. I'm now in a permanent registrar post in Sydney.",
    authorName: 'Dr James O.',
    authorRole: 'General Medicine Registrar',
    grade: 'Dir Med Ser',
    tagLabel: 'Visa sponsored · Permanent',
    tagVariant: 'primary',
  },
  {
    id: 'mei-l',
    rating: 5,
    quote:
      'The telehealth psychiatry roster means I work from a regional base but keep a Sydney caseload. My consultant matched it to my lifestyle exactly.',
    authorName: 'Dr Mei L.',
    authorRole: 'Psychiatry Registrar',
    grade: 'Registrar',
    tagLabel: 'Telehealth · Ongoing',
    tagVariant: 'secondary',
  },
  {
    id: 'sam-k',
    rating: 5,
    quote:
      "My consultant found me back-to-back anaesthetics locums across three states before I'd even finished my first placement. I haven't had a gap in my calendar since.",
    authorName: 'Dr Sam K.',
    authorRole: 'Anaesthetics Registrar',
    grade: 'Registrar',
    tagLabel: 'Zero gaps · Locum',
    tagVariant: 'primary',
  },
  {
    id: 'aroha-w',
    rating: 5,
    quote:
      "Moving rural for a placement felt daunting until my consultant sorted flights, a car and housing before I'd even landed. It made the whole transition painless.",
    authorName: 'Dr Aroha W.',
    authorRole: 'Rural Generalist',
    grade: 'Universal',
    tagLabel: 'Flights & housing sorted · Locum',
    tagVariant: 'secondary',
  },
  {
    id: 'michael-t',
    rating: 5,
    quote:
      "I told my consultant exactly what I wanted in a permanent post and two weeks later I had three genuine offers to choose from. It's been a great fit ever since.",
    authorName: 'Dr Michael T.',
    authorRole: 'Emergency Medicine Consultant',
    grade: 'Dir Med Ser',
    tagLabel: 'Contract renewed · Permanent',
    tagVariant: 'primary',
  },
];
